export default __webpack_public_path__ + "static/media/74-PrinceEdwardIsland-Logo.ecc1b9cc.jpg";